














import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Area1 from './parts/area'
import Bed from './parts/bed'
@Component({
	components: {Area1, Bed}
})
export default class Machine extends AbpBase {
	activeName = "first"


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/machine/index.vue